import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from 'components/shared';

import { useGetOptions } from '../hooks/useGetOptions';

interface Props {
  disabled: boolean;
}

const PeriodTypeSvcSelect = ({ disabled = false }: Props) => {
  const { t } = useTranslation('common');
  const options = useGetOptions();
  const { control } = useFormContext();

  return (
    <ControlledSelect
      disabled={disabled}
      variant="outlined"
      name="periodTypeSvc"
      control={control}
      options={options}
      label={t('holidayHours.grid.periodTypeSvc')}
    />
  );
};

export default PeriodTypeSvcSelect;
